import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseGetSurvey } from 'entities/Surveys/api/types'

export class SurveyRow extends RowBase<IResponseGetSurvey> {
  constructor(origin: IResponseGetSurvey) {
    super(origin)
    makeObservableRowBase(this)
  }

  get id() {
    return this.origin.id
  }

  get name() {
    return this.origin.name
  }

  get status() {
    return this.origin.status
  }

  get npsScore() {
    return this.origin.nps_score
  }

  get totalSent() {
    return this.origin.total_sent
  }

  get validReplies() {
    return this.origin.valid_replies
  }

  get invalidReplies() {
    return this.origin.invalid_replies
  }

  get undelivered() {
    return this.origin.undelivered
  }

  get expired() {
    return this.origin.expired
  }

  get validRepliesPercent() {
    if (!this.origin.total_sent) return 0
    return Math.round((this.origin.valid_replies / this.origin.total_sent) * 100)
  }

  get invalidRepliesPercent() {
    if (!this.origin.total_sent) return 0
    return Math.round((this.origin.invalid_replies / this.origin.total_sent) * 100)
  }

  get undeliveredPercent() {
    if (!this.origin.total_sent || this.origin.undelivered === null) return 0
    return Math.round((this.origin.undelivered / this.origin.total_sent) * 100)
  }

  get expiredPercent() {
    if (!this.origin.total_sent || this.origin.expired === null) return 0
    return Math.round((this.origin.expired / this.origin.total_sent) * 100)
  }
}
